import React from 'react'
import Navbar from '../components/sections/Navbar'
import Footer from '../components/sections/Footer'
import { useSEO } from '../hooks/useSEO'

export default function DisclaimerPage() {
  useSEO({
    title: 'Disclaimer | AugmentAppz',
    description: 'Important legal notices and limitations of liability for AugmentAppz platform and services.',
  })

  return (
    <>
      <Navbar />
      <main className="legal-page">

        <div className="legal-page__hero">
          <div className="container">
            <p className="legal-page__badge">Legal</p>
            <h1 className="legal-page__title">Disclaimer</h1>
            <p className="legal-page__subtitle">
              Important legal notices and limitations of liability for our platform and services.
            </p>
          </div>
        </div>

        <div className="container legal-page__body">

          <section className="legal-section">
            <h2 className="legal-section__heading">Website Disclaimer</h2>
            <p className="legal-section__text">
              The information provided by AUGMENTAPPZ PRIVATE LIMITED (&ldquo;we&rdquo;, &ldquo;us&rdquo;, or &ldquo;our&rdquo;) on our website and
              platform is for general informational purposes only. All information on the site is provided in good faith;
              however, we make no representation or warranty of any kind, express or implied, regarding the accuracy,
              adequacy, validity, reliability, availability, or completeness of any information on the site.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__heading">External Links Disclaimer</h2>
            <p className="legal-section__text">
              Our website may contain links to other websites or content belonging to or originating from third parties.
              Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity,
              reliability, availability, or completeness by us. We do not warrant, endorse, guarantee, or assume
              responsibility for the accuracy or reliability of any information offered by third-party websites linked
              through the site.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__heading">Professional Disclaimer</h2>
            <p className="legal-section__text">
              The site cannot and does not contain professional advice. The information is provided for general
              informational and educational purposes only and is not a substitute for professional advice. Accordingly,
              before taking any actions based upon such information, we encourage you to consult with the appropriate
              professionals. We do not provide any kind of professional advice.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__heading">Errors and Omissions Disclaimer</h2>
            <p className="legal-section__text">
              While we have made every attempt to ensure that the information contained on this site has been obtained
              from reliable sources, AUGMENTAPPZ PRIVATE LIMITED is not responsible for any errors or omissions or for
              the results obtained from the use of this information. All information on this site is provided &ldquo;as is&rdquo;,
              with no guarantee of completeness, accuracy, timeliness, or of the results obtained from the use of
              this information.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__heading">Fair Use Disclaimer</h2>
            <p className="legal-section__text">
              This site may contain copyrighted material the use of which has not always been specifically authorized
              by the copyright owner. We are making such material available in our efforts to advance understanding of
              technological, business, and related issues. We believe this constitutes a &lsquo;fair use&rsquo; of any such
              copyrighted material as provided for in applicable copyright law.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__heading">Contact Us</h2>
            <p className="legal-section__text">If you have any questions about this Disclaimer, please contact us:</p>
            <div className="legal-contact-card">

              {/* Company header */}
              <div className="lcc-company">
                <span className="lcc-company-icon" aria-hidden="true">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M3 21h18M3 7l9-4 9 4M4 7v14M20 7v14M9 21V12h6v9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
                <span className="lcc-company-name">AUGMENTAPPZ PRIVATE LIMITED</span>
              </div>

              {/* Info rows */}
              <ul className="lcc-rows" role="list">

                <li className="lcc-row">
                  <span className="lcc-row-icon" aria-hidden="true">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </span>
                  <div className="lcc-row-body">
                    <span className="lcc-row-label">Email</span>
                    <a href="mailto:support@augmentappz.ai" className="lcc-row-value">support@augmentappz.ai</a>
                  </div>
                </li>

              </ul>
            </div>
          </section>

        </div>
      </main>
      <Footer />
    </>
  )
}
